import React from 'react';
import { Box, Typography } from '@mui/material';
import { useLanguage } from '../../../context/LanguageContext';

const AdvancedSearch = () => {
    const { t } = useLanguage();
    
    return (
        <Box sx={{ p: 1.5 }}>
            <Typography variant="h4" component="h1">
                {t('pages.marketing.advancedSearch')}
            </Typography>
        </Box>
    );
};

export default AdvancedSearch;
